import { DeliveryTypes } from "@utils/enums";

import { getUserInfo } from "@services/tracking/trackers/pageImpressionTracker";
import {
    TOOL_CHECKOUT_CONTEXT,
    TOOL_CHECKOUT_STEPS,
} from "@services/tracking/trackers/tools/checkout/config";
import {
    trackCheckoutToolStep,
    trackCheckoutToolStepForOrder,
} from "@services/tracking/trackers/tools/checkout/tracker";
import { EventTypes } from "@services/tracking/types/eventTypes";
import { StepVariables } from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";
import { OrderDetailsModel } from "@redux/modules/api/data/orderDetail/@types/orderDetails.model";

const trackCheckoutStepCart = (cart: CartModel) => {
    trackCheckoutToolStep(
        EventTypes.ToolStep,
        TOOL_CHECKOUT_STEPS.cartStep,
        TOOL_CHECKOUT_CONTEXT,
        cart,
    );
};

const trackCheckoutStepLogin = (cart: CartModel) => {
    trackCheckoutToolStep(
        EventTypes.ToolStep,
        TOOL_CHECKOUT_STEPS.loginStep,
        TOOL_CHECKOUT_CONTEXT,
        cart,
    );
};

const trackCheckoutStepUserInfo = (cart: CartModel) => {
    trackCheckoutToolStep(
        EventTypes.ToolStep,
        {
            ...TOOL_CHECKOUT_STEPS.userInfoStep,
            result: { customerid: getUserInfo().clientID },
        },
        TOOL_CHECKOUT_CONTEXT,
        cart,
    );
};

const trackCheckoutStepPayment = (cart: CartModel) => {
    trackCheckoutToolStep(
        EventTypes.ToolStep,
        {
            ...TOOL_CHECKOUT_STEPS.paymentStep,
            result: { customerid: getUserInfo().clientID },
        },
        TOOL_CHECKOUT_CONTEXT,
        cart,
    );
};

const trackCheckoutStepConfirmation = (order: OrderDetailsModel) => {
    const deliveryMethods: Array<DeliveryTypes> = [];

    if (
        order.items.some(i => i.deliveryType === DeliveryTypes.ClickAndCollect)
    ) {
        deliveryMethods.push(DeliveryTypes.ClickAndCollect);
    }

    if (order.items.some(i => i.deliveryType === DeliveryTypes.HomeDelivery)) {
        deliveryMethods.push(DeliveryTypes.HomeDelivery);
    }

    const step: StepVariables = {
        ...TOOL_CHECKOUT_STEPS.confirmationStep,
        result: {
            customerid: getUserInfo().clientID,
            deliverymethod: deliveryMethods.join(","),
        },
    };

    trackCheckoutToolStepForOrder(
        EventTypes.ToolStepSubmit,
        step,
        TOOL_CHECKOUT_CONTEXT,
        order,
    );
};

export {
    trackCheckoutStepCart,
    trackCheckoutStepLogin,
    trackCheckoutStepUserInfo,
    trackCheckoutStepPayment,
    trackCheckoutStepConfirmation,
};
